import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core'
import { HideZeroValuesPipe } from '../hide-zero-values.pipe'
import { environment } from 'environments/environment'

export interface OOHTag {
  id: number
  label: string
  name: string
}

export interface OOHTagConfig {
  label: string
  tags: string[]
}

export interface OOHTagGroup {
  label: string
  tags: OOHTag[]
}

@Component({
  standalone: false,
  selector: 'app-tag-selector',
  templateUrl: './tag-selector.component.html',
  styleUrls: ['./tag-selector.component.scss'],
})
export class TagSelectorComponent implements OnInit, OnChanges {
  @HostBinding('class.open') open = false

  @Input() stats: { min: number; max: number; count: number } = null
  @Input() tags: OOHTagGroup[] = []

  @Input() tagsSelected: number[][] = []
  @Output() onTagsChange = new EventEmitter<number[][]>()

  @Input() minMaxSelected: number[] = []
  @Output() onMinMaxChange = new EventEmitter<number[]>()

  reachFilter = []
  politis = !!environment.politis

  sliderFormatFn = (value) => this.formatNumberPipe.transform(value)

  get applyFilterDisabled() {
    return (
      this.minMaxSelected[0] === this.reachFilter[0] &&
      this.minMaxSelected[1] === this.reachFilter[1]
    )
  }

  constructor(protected formatNumberPipe: HideZeroValuesPipe) {}

  ngOnInit() {
    this.parseItems()
  }

  ngOnChanges() {
    this.parseItems()
  }

  parseItems() {
    if (this.stats && this.reachFilter.length === 0) {
      this.reachFilter = [this.stats.min, this.stats.max]
    }
  }

  onSliderChange(value) {
    this.reachFilter = value
  }

  toggleOpen() {
    this.open = !this.open
  }

  isAllSelected(groupIdx) {
    return !this.tagsSelected[groupIdx] || !this.tagsSelected[groupIdx].length
  }

  isTagSelected(tag, groupIdx) {
    return (
      this.tagsSelected[groupIdx] &&
      this.tagsSelected[groupIdx].indexOf(tag.id) !== -1
    )
  }

  clearGroup($event, groupIdx) {
    $event.stopPropagation()
    this.tagsSelected[groupIdx] = []
    this.onTagsChange.emit(this.tagsSelected)
  }

  selectTag($event, tag, groupIdx) {
    $event.stopPropagation()
    const selection = this.tagsSelected
    if (this.isTagSelected(tag, groupIdx)) {
      selection.forEach((g, idx) => {
        selection[idx] = selection[idx].filter((t) => t !== tag.id)
      })
    } else {
      const idx = this.tags.findIndex((g) =>
        g.tags.some((t) => t.id === tag.id),
      )
      if (!selection[idx]) {
        selection[idx] = []
      }
      selection[idx].push(tag.id)
    }
    this.onTagsChange.emit(selection)
  }

  applyReachFilter() {
    this.onMinMaxChange.emit([...this.reachFilter])
  }
}
